(function (angular) {
	'use strict';

	angular
		.module('settingsModule')
		.controller('SecurityQuestionSettings', [
			'SettingsFactory',
			'urlFactory',
			SecurityQuestionSettingsFunction
		]);

	function SecurityQuestionSettingsFunction(
		SettingsFactory,
		urlFactory
	) {
		var securityQuestions = this;

		function buildPayload() {
			return {
				question1: securityQuestions.question1.value,
				answer1: securityQuestions.answer1,
				question2: securityQuestions.question2.value,
				answer2: securityQuestions.answer2
			};
		}

		securityQuestions.handleSubmit = function() {
			SettingsFactory.securityQuestions.set(buildPayload(), securityQuestions.securityQuestionsForm)
				.then(function() {
					urlFactory.redirect("/account/security-questions/save-success");
				})
				.catch(function() {
					securityQuestions.formSubmitted = false;
				});
		};

		securityQuestions.$onInit = function() {
			securityQuestions.formSubmitted = false;
			securityQuestions.loading = true;

			securityQuestions.answerError = {pattern: 'Answer must be at least 3 characters'};
			securityQuestions.answerConfirmError = {pattern: 'Answer must be at least 3 characters', valueMatches: 'Answers must match'};

			SettingsFactory.securityQuestions.get()
				.then(function(response) {
					angular.extend(securityQuestions, response);

					securityQuestions.question1 = securityQuestions.questionList1[0];
					securityQuestions.question2 = securityQuestions.questionList2[0];
					securityQuestions.loading = false;
				});
		};
	}
})(window.angular);